exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background-position: top left;\n  background-repeat: repeat;\n  font-family: \"Open Sans\", serif;\n  overflow: hidden;\n  color: #222222; }\n\nimg {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.ng-draggable.dragging {\n  cursor: move !important; }\n\n#toast-container > .toast {\n  box-shadow: 0 0 12px black !important; }\n\n[draggable=\"true\"] {\n  -khtml-user-drag: element; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/mac/PlayGround/~/postcss-loader?{"ident":"postcss"}!/Users/mac/PlayGround/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/mac/PlayGround/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = 1